(() => {
  const playVideo = videoEl => {
    videoEl
      .play()
      .then(() => {
        // eslint-disable-next-line no-console
        console.log('Autoplay success!');
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.log('Autoplay error', error);
      });
  };
  const videoEls = document.querySelectorAll('.js-video');
  videoEls.forEach(el => {
    playVideo(el);
  });
})();
